<template>
  <v-layout row wrap :class="`${layoutClass}`">
    <v-flex xs8 offset-xs2 md6 offset-md3>
      <v-img :src="require('@/assets/404_Illustration.svg')" contain> </v-img>
    </v-flex>
    <v-flex xs12 md8 offset-md2 class="pa-3 text-xs-center">
      <div v-html="$t('404.pageNotFound')" :class="`${titleClass} pa-1`"></div>
      <div
        v-html="$t('404.isAddressCorrect')"
        :class="`${subTitleClass} pa-1`"
      ></div>
      <div
        v-html="$t('404.contactUsIfMistake')"
        :class="`${subTitleClass} pa-1`"
      ></div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    layoutClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "pa-5 grey--top--border";
      } else if (this.$vuetify.breakpoint.sm) {
        return "pa-3";
      } else if (this.$vuetify.breakpoint.xs) {
        return "pa-2";
      }
      return "";
    },
    titleClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "text-h4";
      } else if (this.$vuetify.breakpoint.sm) {
        return "text-h6";
      } else if (this.$vuetify.breakpoint.xs) {
        return "text-h6";
      }
      return "";
    },
    subTitleClass() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return "text-h5";
      } else if (this.$vuetify.breakpoint.sm) {
        return "subheading";
      } else if (this.$vuetify.breakpoint.xs) {
        return "subheading";
      }
      return "";
    }
  },
  methods: {}
};
</script>
<style scoped></style>
